import { useMemo, useState } from "react";
import { Search, History, Users } from "lucide-react";

export default function CustomersView({ customers, onOpen }) {
  const [q, setQ] = useState("");
  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    const d = s.replace(/\D/g, "");
    return s ? customers.filter((c) => c.name.toLowerCase().includes(s) || (d && c.mobile.replace(/\D/g, "").includes(d))) : customers;
  }, [customers, q]);

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/60" data-testid="customers-section">
      <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-slate-800">
        <p className="font-heading font-bold flex items-center gap-2"><Users size={16} className="text-amber-400" /> Customers <span className="text-slate-500 font-mono text-sm" data-testid="customers-count">({customers.length})</span></p>
        <div className="relative">
          <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500" />
          <input className="cf-input h-8 text-xs w-64" style={{ paddingLeft: 30 }} placeholder="Customer name or mobile…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="customers-search-input" />
        </div>
      </div>
      {shown.length === 0 ? (
        <p className="p-8 text-center text-sm text-slate-500" data-testid="customers-empty">{customers.length ? "No customers match your search." : "Customers appear here once cards have a customer name or mobile number."}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="customers-table">
            <thead>
              <tr className="text-left text-[10px] font-mono uppercase tracking-wider text-slate-500 border-b border-slate-800">
                <th className="px-5 py-3">Customer name</th><th className="px-4 py-3">Mobile</th><th className="px-4 py-3">Certificates</th>
                <th className="px-4 py-3">Latest certificate</th><th className="px-4 py-3">Last visit</th><th className="px-4 py-3 text-right">History</th>
              </tr>
            </thead>
            <tbody>
              {shown.map((c, i) => (
                <tr key={c.key} className="border-b border-slate-800/60 hover:bg-slate-800/30 cursor-pointer" onClick={() => onOpen(c)} data-testid={`customer-row-${i}`}>
                  <td className="px-5 py-2.5 font-semibold text-slate-200">{c.name || "—"}</td>
                  <td className="px-4 py-2.5 font-mono text-slate-300">{c.mobile || "—"}</td>
                  <td className="px-4 py-2.5">
                    <span className={`px-2 py-0.5 rounded-full font-mono text-[11px] ${c.cards.length > 1 ? "bg-amber-500/15 text-amber-300" : "bg-slate-800 text-slate-400"}`} data-testid={`customer-cert-count-${i}`}>
                      {c.cards.length}{c.cards.length > 1 ? " · repeat" : ""}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 font-mono text-slate-400">{c.cards[0]?.data.CERT_NO}</td>
                  <td className="px-4 py-2.5 text-slate-500">{c.last ? new Date(c.last).toLocaleDateString() : ""}</td>
                  <td className="px-4 py-2.5 text-right">
                    <button className="cf-btn-ghost h-7 text-[11px]" data-testid={`customer-history-${i}`}><History size={12} /> View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
